const logotext = "MJT";
const meta = {
    title: "Muhammad Junaid Tariq",
    description: "I’m Muhammad Junaid Tariq Software Engineer _ Full Stack Engineer,currently working in Sialkot",
};

const introdata = {
    title: "I’m Muhammad Junaid Tariq",
    animated: {
        first: "Engineered for excellence",
        second: "I do web development",
        third: "I do cross platform mobile apps",
    },
    description: "Diligent software engineering graduate with 1.5 years experience in software development.Eager to build innovative and cutting edge business solutions for clients Seeking to use proven skills in JavaScript, React, React Native, MERN and project management to meet business needs.",
    your_img_url: process.env.PUBLIC_URL + '/assets/junaid.jpeg',
    // "https://images.unsplash.com/photo-1514790193030-c89d266d5a9d",
};

const dataabout = {
    title: "abit about my self",
    aboutme: "Diligent software engineer with 1+ years experience in commercial application development. Eager to build innovative and cutting edge business solutions for the impressive suite of clients. In previous roles, slashed downtime by 10-15% and ensured 98% on-time project completion. Also identified and dealt with a significant process bottleneck that boosted coding efficiency when resolved."
};
const worktimeline = [{
        jobtitle: "Developer of month",
        where: "datafuction.ca",
        date: "Nov 2021",
    },
    {
        jobtitle: "Developer of month",
        where: "datafuction.ca",
        date: "Jan 2022",
    },
    {
        jobtitle: "Developer of month",
        where: "datafuction.ca",
        date: "Feb 2022",
    },
];

const skills = [{
        name: "Javascript",
        value: 90,
    },
    {
        name: "React",
        value: 87,
    },
    {
        name: "Node JS/Express",
        value: 80,
    },
    {
        name: "No SQL/Mongo DB",
        value: 78,
    },
    {
        name: "SQL",
        value: 79,
    },
    {
        name: "Java",
        value: 70,
    },
    {
        name: "Spring",
        value: 65,
    },
    {
        name: "Python",
        value: 69,
    },
    {
        name: "Django",
        value: 66,
    },
    {
        name: "Software Design and Arch",
        value: 80,
    },
];

const services = [{
        title: "Design & Arch",
        description: "Have experience and specialization in design complex web application. Achieved 10 to 15% increase in user satisfaction and huge increase in performance conversions through following design standards. Looking to leverage my skills to bring monetized improvements to your software."
    },
    {
        title: "Mobile Apps",
        description: "Organized, collaborative, and highly skilled react native developer with 1+ years of professional experience in dynamic work environments. single code base for both ios and android apps"
    },
    {
        title: "Web Apps",
        description: "Dedicated and efficient full stack developer with 2+ years experience in application layers, presentation layers, and databases. Certified in both F/E and B/E technologies. Worked on MERN to cut latency by 40% and increased effectiveness of database administrators by 20%.Skilled in Html,CSS, Javscript and React, MERN",
    },
];

const dataportfolio = [{
        img: process.env.PUBLIC_URL + '/assets/portfolio.png',
        desctiption: "html,css & js based portfolio website",
        link: "http://immjunaid.surge.sh"
    },
    {
        img: process.env.PUBLIC_URL + '/assets/erp.png',
        desctiption: "ERP system for managing hrm, orders and logistics in business.",
        link: "https://erp-systems.netlify.app",
    },
    {
        img: process.env.PUBLIC_URL + '/assets/expense-tracker.png',
        desctiption: "expense tracker for tracking monthly expense and earnings",
        link: "http://expense-tracker-mjunaid.surge.sh",
    },
    {
        img: process.env.PUBLIC_URL + '/assets/covid-tracker.png',
        desctiption: "Covid tracker for live updates about covid19, implemented using public APIs",
        link: "http://covid-tracker-mjunaid.surge.sh",
    },
    {
        img: process.env.PUBLIC_URL + '/assets/chat.png',
        desctiption: "Real time chat app build with react and express",
        link: "https://jtchat.netlify.app",
    },
    {
        img: process.env.PUBLIC_URL + '/assets/smart-diagnose.png',
        desctiption: "IoT base system for disgnosing temperature, blood pressure, height etc.",
        link: "http://smartdiagnosis.surge.sh/",
    },
    {
        img: process.env.PUBLIC_URL + '/assets/event-booking.png',
        desctiption: "event booking web & mobile app for event booking services.",
        link: "https://black-velvet-1ae7c.firebaseapp.com",
    },
];

const contactConfig = {
    YOUR_EMAIL: "junaidt07@gmail.com",
    YOUR_FONE: "(92)317-7336448",
    description: "Diligent software engineering graduate with 1.5 years experience in software development.Eager to build innovative and cutting edge business solutions for clients Seeking to use proven skills in JavaScript, React, React Native, MERN and project management to meet business needs.",
    YOUR_SERVICE_ID: "service_b5gaz4s",
    YOUR_TEMPLATE_ID: "template_3k06zg7",
    YOUR_USER_ID: "mD3WBnMk0bB73kzpB",
};

const socialprofils = {
    github: "https://github.com/mjunaidjt",
    facebook: "https://facebook.com/muhammadjunaid.tariq.9047",
    linkedin: "https://www.linkedin.com/in/immjunaidtariq",
    twitter: "https://twitter.com",
    youtube: "https://youtube.com",
    twitch: "https://twitch.com",
};
export {
    meta,
    dataabout,
    dataportfolio,
    worktimeline,
    skills,
    services,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};